import { Label } from "../common/GeneralClasses";

export class UnsubsribeFormLabels {
  constructor(
    public title = new Label("title", ""),
    public subtitle = new Label("subtitle", ""),
    public button = new Label("button", ""),
    public footer = new Label("footer", ""),
    public policyLinks = new Label("policy-links", ""),
    public thankYou = new Label("thank-you", ""),
    public error = new Label("error", ""),
    public confirmButtonLabel = new Label("confirm-button", ""),
    public thankYouBulkUnsubscribe = new Label("thank-you-bulk", ""),
    public brandHomepageUrl = new Label("brand-homepage-url", "")
  ) {}
}
